import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'components'

const MEDIA_ALT_SECTION_ID = 'youtube-welcome-video-media-alt'

const propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  srcUrl: PropTypes.string.isRequired,
  iframeTitle: PropTypes.string,
  mediaAlternative: PropTypes.node,
}

const defaultProps = {
  iframeTitle: 'YouTube video player',
  mediaAlternative: null,
}

function YoutubeVideoModal({
  onClose,
  isOpen,
  srcUrl,
  iframeTitle,
  mediaAlternative,
  ...rest
}) {
  const [size, setSize] = useState({
    width: window.innerWidth * 0.7,
    height: window.innerHeight * 0.6,
  })

  useEffect(() => {
    function handleResize() {
      setSize({
        width: window.innerWidth * 0.7,
        height: window.innerHeight * 0.6,
      })
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const showMediaAlt = mediaAlternative != null && mediaAlternative !== false

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton={true}
      shouldCloseOnOverlayClick={true}
      preventScroll={true}
      {...rest}
    >
      <React.Fragment>
        <iframe
          width={size.width}
          height={size.height}
          src={srcUrl}
          title={iframeTitle}
          aria-describedby={showMediaAlt ? MEDIA_ALT_SECTION_ID : undefined}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
        {showMediaAlt ? (
          <section
            id={MEDIA_ALT_SECTION_ID}
            className="youtube-video-modal-media-alt"
            tabIndex={-1}
          >
            <h2 className="youtube-video-modal-media-alt-title">
              Text version of this video
            </h2>
            {mediaAlternative}
          </section>
        ) : null}
      </React.Fragment>
    </Modal>
  )
}

YoutubeVideoModal.propTypes = propTypes
YoutubeVideoModal.defaultProps = defaultProps

export default YoutubeVideoModal
